module.exports = __webpack_public_path__ + "static/media/Preeti M.4856a84b.png";